import { MuiDropDown } from "../../../components/basicComponent/MuiDropDown";
import { MuiInput } from "../../../components/basicComponent/MuiInput";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { PriorityStatus } from "../../../constants/constant";
import MuiButton from "../../../components/basicComponent/MuiButton";
import { UtilService } from "../../../services/shared/UtilService";
import {
  capitalizeFirstLetter,
  generateRandomInteger,
  removeUnderscores,
} from "../../../constants/helper";
import SideMenu from "../../../sharedScreens/menuItems/SideMenu";
import Header from "../../../sharedScreens/Header";
import NoDataFlightCard from "../../../components/composite/NoDataFlightCard";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import ConfirmationModal from "../../../components/basicComponent/ConfirmationModal";
import { msgTypes } from "../../../constants/msgTypes";
import MuiSearchSelect from "../../../components/basicComponent/MuiSearchSelect";
import { useSweetAlert } from "../../../services/customHooks/useSweetAlert";
import { TopupRequestByCorporateUserSchema } from "../../../validations/Schema";
const ITEMS_PER_PAGE = 10;
const TopupRequestByCorporateUser = () => {
  const { showSuccess, showError } = useSweetAlert();
  const [list, setList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(ITEMS_PER_PAGE);
  const [isShowConfirmationPopup, setIsShowConfirmationPopup] =
    useState<boolean>(false);
  const [id, setId] = useState("");
  const [amt, setAmt] = useState<string>("");
  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: "asc" | "desc";
  }>({ key: "", direction: "asc" });
  const [
    isShowNewRequestConfirmationPopup,
    setIsShowNewRequestConfirmationPopup,
  ] = useState<boolean>(false);
  const initialValues = {
    reference_id: "",
    amount: "",
    user_note: [{ userNote: "" }, { corporateNote: "" }],
    priority: "",
    remark: "",
  };
  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: TopupRequestByCorporateUserSchema,
    onSubmit: async (values, formikHelpers) => {
      const { id, amount } = await checkPendingRequest();
      setAmt(amount);
      if (!!id) {
        setId(id);
        setIsShowConfirmationPopup(true);
      } else {
        setIsShowNewRequestConfirmationPopup(true);
      }
    },
  });

  const createTopupRequest = async () => {
    const payload = {
      amount: formik.values.amount,
      priority: formik.values.priority,
      user_note: formik.values.user_note,
      reference_id: "TXN_" + generateRandomInteger(),
    };
    try {
      setIsShowNewRequestConfirmationPopup(false);
      const response = await UtilService.createTopUpRequest(payload);
      if (response.statusMsg === msgTypes.SUCCESS.msg) {
        formik.resetForm();
        getListOfTopupRequest();
        showSuccess(
          "Success!",
          `Topup request created successfully with Amount:
            ${formik.values.amount}`,
          { timer: 3000, timerProgressBar: true }
        );
      } else {
        showError("Oops...", response?.statusRemark ?? "Something went wrong!");
      }
    } catch (error) {
      console.log("error inside create topup request", error);
    }
  };
  useEffect(() => {
    getListOfTopupRequest();
  }, []);
  const getListOfTopupRequest = async (selectedStatus?: string) => {
    const params = {
      status: selectedStatus,
    };
    const response = await UtilService.getTopupRequestList(params);
    if (!!response) {
      setList(response.data);
    }
  };
  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };
  const getSortedAndPagedData = () => {
    let sorted = [...list];

    if (sortConfig.key) {
      sorted.sort((a: any, b: any) => {
        const aVal = new Date(a[sortConfig.key]).getTime();
        const bVal = new Date(b[sortConfig.key]).getTime();
        return sortConfig.direction === "asc" ? aVal - bVal : bVal - aVal;
      });
    }

    return sorted.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );
  };

  // Calculate the data for the current page
  const currentData = getSortedAndPagedData();
  const handleSort = (key: string) => {
    setSortConfig((prev) => {
      const direction =
        prev.key === key && prev.direction === "asc" ? "desc" : "asc";
      return { key, direction };
    });
  };
  const handleCancelBtn = async () => {
    setIsShowConfirmationPopup(false);
  };
  const checkPendingRequest = async () => {
    const params = {
      status: "pending",
    };
    const response = await UtilService.getTopupRequestList(params);
    const isStatusOtpPending = response?.data?.length > 0;
    const id = isStatusOtpPending && response?.data?.[0]?.id;
    const amount = response?.data?.[0]?.amount;
    return { id, amount };
  };
  const handleSubmit = async () => {
    const { id, amount } = await checkPendingRequest();
    setAmt(amount);
    if (!!id) {
      setId(id);
      setIsShowConfirmationPopup(true);
    } else {
      setIsShowNewRequestConfirmationPopup(true);
    }
  };
  return (
    <>
      <div className="grow">
        <SideMenu />
        <div className="wrapper flex grow flex-col">
          <Header />
          <main className="grow content" id="content" role="content">
            <div className="container-fixed">
              {/* <div className="card-header text-center">
              <h3 className="card-title">Topup Request</h3>
            </div> */}
              <div className="card-header mb-1 managebookingg">
                <h3 className="card-title titlecolorr">Topup Request</h3>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-custom">
                    <div className="card-body">
                      <>
                        <div className="row mt-4">
                          <div className="col-md-4 mb-md-0 mb-4 mb-md-0">
                            <MuiInput
                              label="Amount"
                              placeholder="Amount"
                              value={formik.values.amount}
                              onChange={(e) =>
                                formik.setFieldValue("amount", e)
                              }
                              onBlur={() =>
                                formik.setFieldTouched("amount", true)
                              }
                              isInvalid={
                                formik.touched.amount &&
                                Boolean(formik.errors.amount)
                              }
                              errorText={
                                formik.touched.amount && formik.errors.amount
                                  ? formik.errors.amount
                                  : ""
                              }
                              type="number"
                            />
                          </div>
                          <div className="col-md-4 mb-md-0 mb-4 mb-md-0">
                            <MuiDropDown
                              label="priority"
                              options={PriorityStatus}
                              onChange={(val) => {
                                formik.setFieldValue("priority", val);
                              }}
                              value={formik.values.priority}
                              placeholder="Priority"
                              isInvalid={
                                formik.touched.priority &&
                                Boolean(formik.errors.priority)
                              }
                              errorText={
                                formik.touched.priority &&
                                formik.errors.priority
                                  ? formik.errors.priority
                                  : ""
                              }
                            />
                          </div>
                          <div className="col-md-4">
                            <MuiInput
                              label={"Remark"}
                              onChange={(val) => {
                                formik.setFieldValue(
                                  "user_note[0].userNote",
                                  val
                                );
                                formik.setFieldValue("remark", val);
                              }}
                              value={formik.values.remark}
                              placeholder="Remark"
                              isInvalid={
                                formik.touched.remark &&
                                Boolean(formik.errors.remark)
                              }
                              errorText={
                                formik.touched.remark && formik.errors.remark
                                  ? formik.errors.remark
                                  : ""
                              }
                            />
                          </div>
                        </div>
                        <div className="user-button mt-4">
                          <MuiButton
                            className="clear-btn"
                            label="Clear"
                            type="reset"
                            onClick={() => formik.resetForm()}
                          />
                          <MuiButton
                            className="main-btn get-btn"
                            variant="contained"
                            size="large"
                            type="submit"
                            label="Submit"
                            onClick={() => formik.handleSubmit()}
                          />
                        </div>
                        <ConfirmationModal
                          handleClose={() => {
                            handleCancelBtn();
                          }}
                          header={`You have a pending OTP request for ${amt}.Please wait until it's approved or rejected before submitting a new one.`}
                          isVisible={isShowConfirmationPopup}
                          onConfirm={() => {
                            setIsShowConfirmationPopup(false);
                          }}
                          buttonText="Ok"
                        />
                        <ConfirmationModal
                          handleClose={() => {
                            setIsShowNewRequestConfirmationPopup(false);
                          }}
                          header={"Do you want to continue with this request?"}
                          isVisible={isShowNewRequestConfirmationPopup}
                          onConfirm={() => {
                            createTopupRequest();
                          }}
                          buttonText="Ok"
                        />
                      </>
                    </div>
                    {list?.length > 0 ? (
                      <div className="row">
                        <div className="card-body">
                          <div className="table-responsive">
                            <table className="table table-bordered  table-hover align-middle">
                              <thead className="table-dark">
                                <tr>
                                  <th>Reference ID</th>
                                  <th>Amount</th>
                                  <th>Remark</th>
                                  <th>Priority</th>

                                  <th
                                    onClick={() => handleSort("createdAt")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    Created At
                                    {sortConfig.key === "createdAt" &&
                                      (sortConfig.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                  <th
                                    onClick={() => handleSort("updatedAt")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    Updated At
                                    {sortConfig.key === "updatedAt" &&
                                      (sortConfig.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>

                                  <th>Status</th>
                                </tr>
                              </thead>

                              {/* Sample row */}
                              <tbody>
                                {currentData?.length > 0 ? (
                                  currentData?.map((item: any, index) => (
                                    <tr key={item.id} className="text-color">
                                      <td>{item.referenceId}</td>
                                      <td>{item.amount}</td>
                                      <td>
                                        {(item.userNote?.[0]?.userNote ||
                                          item.userNote?.[1]?.userNote) && (
                                          <span>
                                            <span className="fw-bold px-1">
                                              User Note:
                                            </span>
                                            {item.userNote?.[0]?.userNote ??
                                              item.userNote?.[1]?.userNote ??
                                              ""}
                                          </span>
                                        )}
                                        {(item.userNote?.[1]?.corporateNote ||
                                          item.userNote?.[0]
                                            ?.corporateNote) && (
                                          <span>
                                            <span className="fw-bold px-2">
                                              Corporate Note:
                                            </span>
                                            {item.userNote?.[1]
                                              ?.corporateNote ??
                                              item.userNote?.[0]
                                                ?.corporateNote ??
                                              ""}
                                          </span>
                                        )}
                                      </td>
                                      <td>{item.priority}</td>

                                      <td>
                                        {new Date(
                                          item.createdAt
                                        ).toLocaleString()}
                                      </td>
                                      <td>
                                        {new Date(
                                          item.updatedAt
                                        ).toLocaleString()}
                                      </td>
                                      <td
                                        style={{
                                          color:
                                            item.status === "approved"
                                              ? "green"
                                              : item.status === "pending"
                                              ? "orange"
                                              : item.status === "rejected"
                                              ? "#e33a3acc"
                                              : "#64638e",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {removeUnderscores(
                                          capitalizeFirstLetter(item.status)
                                        )}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan={10}>
                                      <NoDataFlightCard
                                        headingText="No Data Found"
                                        icon={
                                          <SearchOffIcon
                                            fontSize="large"
                                            className="text-gray-500"
                                          />
                                        }
                                        paragraph=""
                                      />
                                    </td>
                                  </tr>
                                )}
                              </tbody>

                              {/* Add more rows dynamically */}
                            </table>
                          </div>

                          <div className="card-footer justify-center md:justify-between flex-col md:flex-row gap-5 text-gray-600 text-2sm font-medium">
                            <div className="pagination">
                              <button
                                className="btn "
                                onClick={() =>
                                  handlePageChange(currentPage - 1)
                                }
                                disabled={currentPage === 1}
                              >
                                <i className="ki-outline ki-black-left rtl:transform rtl:rotate-180"></i>
                              </button>
                              <button className="btn active disabled">
                                {currentPage}
                              </button>
                              <button
                                className="btn "
                                onClick={() =>
                                  handlePageChange(currentPage + 1)
                                }
                                disabled={
                                  currentPage * itemsPerPage >= list.length
                                }
                              >
                                <i className="ki-outline ki-black-right rtl:transform rtl:rotate-180"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="row justify-content-center mt-5 ">
                        <div className="col-md-5">
                          <div className="">
                            <div className="flex justify-center items-center bg-gray-50 mt-3">
                              <div className="flex items-center justify-center w-16 h-16 bg-blue-50 rounded-full">
                                <img
                                  src="media/images/remove-folder.png"
                                  alt="remove-folder"
                                />
                              </div>
                            </div>

                            <div className="no-flights-message p-2 text-center">
                              <h3 className="no-data-head">No data found</h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default TopupRequestByCorporateUser;
